var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("AbrobarObservarListaFicha"),
      _vm._v(" "),
      _c("SeguimientoListaFicha"),
      _vm._v(" "),
      _c("Reporte"),
      _vm._v(" "),
      _c(
        "h3",
        { staticClass: "primary--text" },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [_vm._v("business")]),
          _vm._v(" Lista de vacaciones programadas\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c("crud-table", {
                attrs: {
                  headers: _vm.headers,
                  url: _vm.url,
                  "data-graphql": _vm.dataGraphql,
                  graphql: _vm.graphql,
                  initData: _vm.initData
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function(items) {
                      return [
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.nombres))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.fecha_solicitud))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.fecha_desde))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.fecha_hasta))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(items.item.dias_vaca_programada) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.estado))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.nro_id))
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "nowrap text-xs-center" },
                          [
                            items.item.id_estado_ficha != 39
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: { dark: "", color: "success" },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.AbrobarObservarListaFicha(
                                          items.item
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              Aprobar/Rechazar\n            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3aa4b2d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3aa4b2d2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacaciones_aprobar/Index.vue
// module id = null
// module chunks = 